import { ROLES } from '../models/user'

export const isCommercial = (roleId: number): boolean => {
  return [ROLES.commercial, ROLES.commercialC, ROLES.commercialD].includes(roleId)
}

export const isClient = (roleId: number): boolean => {
  return ROLES.client === roleId
}

export const isNotClient = (roleId: number): boolean => {
  return !(ROLES.client !== roleId)
}

export const isManager = (roleId: number): boolean => {
  return [ROLES.superAdmin, ROLES.admin, ROLES.manager].includes(roleId)
}

export const isTrainingManager = (roleId: number): boolean => {
  return ROLES.trainingManager === roleId
}

export const isSuperAdmin = (roleId: number): boolean => {
  return ROLES.superAdmin === roleId
}

export const isAdmin = (roleId: number): boolean => {
  return [ROLES.superAdmin, ROLES.admin].includes(roleId)
}

export const isNotClientAndTrainer = (roleId: number): boolean => {
  return ![ROLES.client, ROLES.trainer].includes(roleId)
}

export const isCommercialOrClientOrTrainer = (roleId: number): boolean => {
  return [ROLES.commercial, ROLES.client, ROLES.trainer, ROLES.commercialC, ROLES.commercialD].includes(roleId)
}

export const isCommercialOrClient = (roleId: number): boolean => {
  return [ROLES.commercial, ROLES.client, ROLES.commercialC, ROLES.commercialD].includes(roleId)
}
